<template>
  <div id="registration" ref="index">
    <section class="form">
      <div class="container">
        <!-- 標題 -->
        <div class="form-header">
          <router-link
            :to="{name: 'volunteer'}"
            class="text-primary d-inline-flex align-items-center pr-3"
          >
            <i class="material-icons">arrow_left</i>
            <strong>BACK</strong>
          </router-link>
          <div class="form-title">
            <h1 class="h4 m-0 text-center text-primary mt-50 mb-20">
              <span class="icon"></span>
              志工報名
            </h1>
          </div>
        </div>
        <!-- 表單 -->
        <form ref="form" class="bg-white">
          <!-- name -->
          <div class="form-group row">
            <label for="volunteer-name" class="col-sm-2 col-form-label">*姓名</label>
            <div class="col-sm-10">
              <input
                id="volunteer-name"
                type="text"
                class="form-control"
                placeholder="請輸入姓名"
                v-model="volunteer.name"
                @click="validate.name=true"
              />
              <!-- @change="validateName()" -->
              <p class="text-danger" v-if="validate.name && validateName">
                <small>請輸入姓名</small>
              </p>
            </div>
          </div>
          <!-- gender -->
          <fieldset class="form-group">
            <div class="row">
              <legend class="col-form-label col-sm-2 pt-0">*性別</legend>
              <div class="col-sm-10 d-flex">
                <div class="form-check mr-md-30 mr-10">
                  <input
                    id="volunteer-gender-female"
                    class="form-check-input"
                    type="radio"
                    name="gender"
                    value="0"
                    v-model.number="volunteer.gender"
                  />
                  <label class="form-check-label" for="volunteer-gender-female">男性</label>
                </div>
                <div class="form-check mr-md-30 mr-10">
                  <input
                    id="volunteer-gender-male"
                    class="form-check-input"
                    type="radio"
                    name="gender"
                    value="1"
                    checked
                    v-model.number="volunteer.gender"
                  />
                  <label class="form-check-label" for="volunteer-gender-male">女性</label>
                </div>
                <div class="form-check">
                  <input
                    id="volunteer-gender-other"
                    class="form-check-input"
                    type="radio"
                    name="gender"
                    value="2"
                    v-model.number="volunteer.gender"
                  />
                  <label class="form-check-label" for="volunteer-gender-other">其他</label>
                </div>
              </div>
            </div>
          </fieldset>
          <!-- phone -->
          <div class="form-group row">
            <label for="volunteer-tel" class="col-sm-2 col-form-label">*電話</label>
            <div class="col-sm-10">
              <input
                id="volunteer-tel"
                type="tel"
                class="form-control"
                placeholder="請輸入電話"
                v-model="volunteer.phone"
                @click="validate.phone=true"
              />
              <p class="text-danger" v-if="validate.phone && validatePhone">
                <small>請輸入電話</small>
              </p>
            </div>
          </div>
          <!-- birth -->
          <div class="form-group row">
            <label for="volunteer-birth" class="col-sm-2 col-form-label">*出生年月日</label>
            <div class="col-sm-10">
              <input
                id="volunteer-birth"
                type="date"
                class="form-control"
                placeholder="年/月/日"
                v-model="volunteer.birth"
                @click="validate.birth=true"
              />
              <p class="text-danger" v-if="validate.birth && validateBirth">
                <small>請輸入出生年月日</small>
              </p>
            </div>
          </div>
          <!-- job -->
          <div class="form-group form-row" ref="category">
            <label for="volunteer-position" class="col-sm-2 col-form-label">*報名職務</label>
            <div class="col-sm-10">
              <input
                id="volunteer-position"
                type="text"
                class="form-control"
                :placeholder="job[0] ? job[0].title:'志工職務' "
                disabled
              />
            </div>
          </div>
          <!-- note -->
          <div class="form-group row">
            <label for="volunteer-other" class="col-sm-2 col-form-label">問題及備註</label>
            <div class="col-sm-10">
              <textarea id="volunteer-other" class="form-control" rows="3" v-model="volunteer.note"></textarea>
            </div>
          </div>
          <!-- 送出 -->
          <div class="form-group row">
            <div class="col-sm-10 ml-auto d-flex justify-content-end">
              <button
                type="submit"
                class="btn btn-sub-primary text-white"
                @click.prevent="postData"
              >報名</button>
            </div>
            <p class="text-right ml-auto my-2">
              <small>報名完成後將儘速與您聯絡！</small>
            </p>
          </div>
        </form>
      </div>
    </section>
   <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'registration',
  data() {
    return {
      category: [],
      job: [],
      volunteer: {
        name: '',
        gender: 0,
        birth: '',
        phone: '',
        category_id: 0,
        note: '',
      },
      validate: {
        name: false,
        birth: false,
        phone: false,
      },
    };
  },
  computed: {
    validateName() {
      return this.volunteer.name === '';
    },
    validateBirth() {
      return this.volunteer.birth === '';
    },
    validatePhone() {
      const re = /^\d+$/;
      return this.volunteer.phone === '' || !re.test(this.volunteer.phone);
    },
  },
  methods: {
    getType() {
      const url = '/category';
      const params = {
        search: 'type:0',
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.category = response.data.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getJob() {
      const loading = this.$loading.show({
        container: this.$refs.category,
      });
      const url = '/article';
      const params = {
        search: this.$route.params.id,
        searchFields: 'no',
        limit: 1,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.job = response.data.data;
          const type = this.category.find(item => item.name === this.job[0].title);
          console.log(type);
          this.volunteer.category_id = type.id;
          loading.hide();
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
          loading.hide();
        });
    },
    postData() {
      const validate = [this.validateName, this.validateBirth, this.validatePhone];
      if (validate.find(item => item === true)) {
        this.$toasted.global.error({ message: '請填寫完整資料！' });
        return false;
      }
      const loading = this.$loading.show({
        container: this.$refs.form,
      });
      const url = '/volunteer';
      const data = new FormData();
      data.append('name', this.volunteer.name);
      data.append('gender', this.volunteer.gender);
      data.append('birth', this.volunteer.birth);
      data.append('phone', this.volunteer.phone);
      data.append('category_id', this.volunteer.category_id);
      data.append('note', this.volunteer.note);

      this.axios
        .post(url, data)
        .then(() => {
          loading.hide();
          this.$fire({
            title: '成功',
            text: '您已報名成功，工作人員將盡速與您聯絡',
            type: 'success',
            timer: 3000,
          }).then((response) => {
            if (response.value === true) {
              this.$router.push({ name: 'volunteer' });
            }
          });
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
          loading.hide();
        });
      return true;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getType();
    this.$nextTick(() => {
      this.getJob();
      setTimeout(() => {
        this.scrollToTop();
      }, 500);
    });
  },
};
</script>
<style lang="scss">
@import '~@/assets/scss/all.scss';
#registration {
  @media (min-width: 576px) {
    background-image: url('~@/assets/images/bg-circle-left.svg'),
      url('~@/assets/images/bg-circle-right.svg');
    background-size: 170px auto, 170px auto;
    background-repeat: repeat-y, repeat-y;
    background-position: left top, right top;
  }
  .icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: $primary;
  }
  section {
    min-height: 450px;
    padding: 40px 0;
    a {
      color: #000000;
      text-decoration: none;
    }
    &.form {
      padding-bottom: 50px;
      .form-header {
        position: relative;
        a {
          font-size: 15px;
          background-color: #fff;
          z-index: 1;
          text-decoration: none;
          i {
            font-size: 40px;
          }
          &::before {
            content: '';
            position: absolute;
            background-color: $primary;
            left: 0;
            right: 0;
            top: 19px;
            height: 4px;
            z-index: -1;
          }
        }
      }
      form {
        border: 1px solid $secondary-white;
        border-radius: 16px;
        padding: 35px 80px;
        .form-group {
          margin-bottom: 2rem;
          input {
            border-radius: 20px;
          }
        }
        button {
          letter-spacing: 2px;
          width: 100px;
        }
      }
    }
  }
}
</style>
